import { TEMPLATES, LAYOUTS } from "../../lib/shield";

export const LayoutPicker = ({ layout, onChange }) => (
  <div className="mb-4" data-testid="layout-picker">
    <div className="eyebrow mb-2">Card layout</div>
    <div className="grid grid-cols-2 gap-2">
      {LAYOUTS.map(([id, name]) => (
        <button key={id} type="button" onClick={() => onChange(id)} data-testid={`layout-option-${id}`} aria-pressed={(layout || "columns") === id}
          className={`flex min-w-0 flex-col items-start gap-1.5 border-2 px-3 py-2.5 text-left ${(layout || "columns") === id ? "border-slate-900 bg-slate-900 text-white" : "border-slate-200 bg-white hover:border-slate-900"}`}>
          <span className="font-cond grid max-w-full gap-0.5 break-words text-[9px] font-bold leading-none opacity-80">
            {id === "row" ? <span>PAC SHO PAS DRI DEF PHY</span> : <><span>PAC · DRI</span><span>SHO · DEF</span><span>PAS · PHY</span></>}
          </span>
          <span className="font-display max-w-full break-words text-sm font-extrabold uppercase leading-tight">{name}</span>
        </button>
      ))}
    </div>
  </div>
);

export const SportPicker = ({ sport, onChange }) => (
  <div className="mb-4" data-testid="sport-picker">
    <div className="eyebrow mb-2">Sport template</div>
    <div className="grid grid-cols-2 gap-2 sm:grid-cols-4">
      {Object.entries(TEMPLATES).map(([id, t]) => (
        <button key={id} type="button" onClick={() => onChange(id)} data-testid={`sport-option-${id}`} aria-pressed={sport === id}
          className={`min-w-0 border-2 px-3 py-2.5 text-left transition-[border-color,background-color] ${sport === id ? "border-slate-900 bg-slate-900 text-white" : "border-slate-200 bg-white hover:border-slate-900"}`}>
          <span className="font-display block break-words text-sm font-extrabold uppercase leading-tight">{t.name}</span>
          <span className={`font-cond block text-xs font-semibold tracking-wider ${sport === id ? "text-lime-300" : "text-slate-500"}`}>{t.stats.map((s) => s.key).join(" · ")}</span>
        </button>
      ))}
    </div>
  </div>
);
